import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import InsuranceConventionGeneralDataContainer from './generalData/InsuranceConventionGeneralDataContainer';
import InsuranceConventionDetailsComponent from './details/InsuranceConventionDetailsComponent';
import { INSURANCE_CONVENTION_QUERY } from '../queries';
import { useQuery } from 'hooks/apollo';
import { FakeText, Card } from '@totalsoft/rocket-ui';
import useLanguageTracker from 'hooks/useLanguageTracker';

const InsuranceConventionContainer = ({ productId, onRedirect }) => {
  const { data, loading, refetch } = useQuery(INSURANCE_CONVENTION_QUERY, {
    variables: { productId },
    skip: productId === undefined || productId === null
  });

  const onLanguageChange = useCallback(() => {
    refetch();
  }, [refetch]);

  useLanguageTracker({
    onChange: onLanguageChange
  });

  return (
    <>
      {loading ? (
        <Card>
          <FakeText lines={15} />
        </Card>
      ) : (
        <>
          <InsuranceConventionGeneralDataContainer
            data={data?.insuranceConvention}
            productId={data?.insuranceConvention?.productId}
            onRedirect={onRedirect}
          />
          <InsuranceConventionDetailsComponent data={data?.insuranceConvention} />
        </>
      )}
    </>
  );
};

InsuranceConventionContainer.propTypes = {
  productId: PropTypes.number,
  onRedirect: PropTypes.func
};

export default InsuranceConventionContainer;
